import '@babel/polyfill';
import smoothscroll from 'smoothscroll-polyfill';
import Vue from 'vue';
import './plugins/vuetify';
import './plugins/sentry';
import './plugins/meta';
import './plugins/analytics';
import './plugins/hotjar';
import App from './App.vue';
import router from './router';

import '@/stylus/main.styl';

smoothscroll.polyfill();

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
